module.exports = __webpack_public_path__ + "media/images/sell_drawing-5ecbf226cadb54a3fd26439ec6404ecb.png";